module.exports = __webpack_public_path__ + "img/howitworks_spending_phone4.11a2c974.jpg";